export default __webpack_public_path__ + "static/media/62.cf477ad2.jpg";